import { fetchMetaData, fetchInfo, fetchPXQ, fetchData, fetchInfoDescription } from './apiFetching';
import { setSelectionFile, setSelectionLang, initQuerySelectionValues, setStubHeadingFromMetaData } from './querySelection';
import { setColumnFromMetadata } from './pivot';
import { errorEmptyParams } from './errors';
import { setStateChart } from './chartAction';
import { setStateCheckEst } from './checkAction';
import { setStateCheckHideRows } from './checkHideRowsAction';
import { setStateCollapseMenuPest1, setStateCollapseMenuPest2 } from './collapseMenuAction';

/*
esta función se encarga de ejecutar las funciones principales
que extraer la información de la API segun los paraemtros recibidos
 */
export const initStore = () => async (dispatch, getState) => {

    const { config } = getState();
    const lang = config.lang;
    const { path } = config;
    let file = '';
    dispatch(errorEmptyParams(false));
    dispatch(setStateChart(false));
    dispatch(setStateCheckEst(false));
    dispatch(setStateCheckHideRows(false));

    try {
        if (path && path.length === 1) {
            await dispatch(fetchPXQ(path[0]));
            await dispatch(fetchMetaData());
            await dispatch(fetchInfo());
            await dispatch(fetchInfoDescription());
            await dispatch(setStateCollapseMenuPest1(true));
            await dispatch(setStateCollapseMenuPest2(true));
            const hr = getState().selection.hiderows;
            dispatch(setStateCheckHideRows(hr));
            if (getState().selection.heading.length === 0 && getState().selection.stub.length === 0) {
                const { stub, heading } = getState().metadata;
                dispatch(setStubHeadingFromMetaData(stub, heading));
                dispatch(setColumnFromMetadata(stub, heading));
            }
            else {
                dispatch(setColumnFromMetadata(getState().selection.stub, getState().selection.heading));
            }
            await dispatch(fetchData());
        } else if (path && path.length > 1) {
            file = path.join('/');
            dispatch(emptyData());
            dispatch(setSelectionLang(lang));
            dispatch(setSelectionFile(file));
            await dispatch(fetchMetaData());
            await dispatch(fetchInfoDescription());
            dispatch(setStateCollapseMenuPest1(false));
            dispatch(setStateCollapseMenuPest2(true));
            const { stub, heading } = getState().metadata;
            dispatch(setStubHeadingFromMetaData(stub, heading));
            dispatch(setColumnFromMetadata(stub, heading));
            await dispatch(initQuerySelectionValues(getState().metadata.variables));
        } else {
            dispatch(errorEmptyParams());
            console.log(' No se ha proporcionado un archivo config valido que contenga un pxq o, bd y px');
        }
    } catch (e) {
        console.log('No se ha proporcionado un archivo config valido que contenga un pxq o, bd y px');
        dispatch(errorEmptyParams());
    }
    dispatch(isLoaded());
}

export const setConfig = (config) => {
    return {
        type: 'SET_CONFIG',
        payload: config
    }
}

const isLoaded = () => {
    return {
        type: 'IS_LOADED',
        payload: false
    }
}

export const collapseTabOptions = (isCollapse) => {
    return {
        type: 'COLLAPSE',
        payload: isCollapse
    }
}

export const collapseAll = (areAllCollase) => {
    return {
        type: 'SET_COLLAPSE_ALL',
        payload: areAllCollase
    }
}

export const collapseAllLineChart = (areAllCollase) => {
    return {
        type: 'SET_COLLAPSE_ALL_LINE_CHART',
        payload: areAllCollase
    }
}

export const collapseAllRadioChart = (areAllCollase) => {
    return {
        type: 'SET_COLLAPSE_ALL_RADIO_CHART',
        payload: areAllCollase
    }
}

export const enableDD = (enableDD) => {
    return {
        type: 'SET_DD_ENABLED',
        payload: enableDD
    }
}
export const collapseNote = (areCollaseNotas) => {
    return {
        type: 'SET_COLLAPSE_NOTE',
        payload: areCollaseNotas
    }
}

export const emptyData = () => {
    return {
        type: 'EMPTY_DATA',
        payload: null
    }
}